namespace GeniuzPOS.Administration {
    export interface UserApprovalRoleForm {
        UserId: Serenity.IntegerEditor;
        ApprGroupCode: Serenity.StringEditor;
    }

    export class UserApprovalRoleForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.UserApprovalRole';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserApprovalRoleForm.init)  {
                UserApprovalRoleForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(UserApprovalRoleForm, [
                    'UserId', w0,
                    'ApprGroupCode', w1
                ]);
            }
        }
    }
}
